import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import authService from '../services/auth.service';
import { useAuthStore } from '../store/authStore';
import { detectMobileOrMiniProgram } from '../utils/supplierView';
import {
  canAccessCompanyCenter,
  resolveDefaultRouteByRole,
} from '../utils/workbenchView';

interface CompanyCenterGuardProps {
  children: React.ReactNode;
}

/**
 * 企业管理中心二次校验：路由白名单之外，以 /auth/me 为准同步角色，避免缓存或多标签页导致误入。
 */
const CompanyCenterGuard: React.FC<CompanyCenterGuardProps> = ({ children }) => {
  const { user, setUser, authInitialized } = useAuthStore();
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const preferMobileLayout = detectMobileOrMiniProgram();

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      if (!authInitialized) return;

      const freshUser =
        (await authService.fetchCurrentUser()) || authService.getCurrentUser();
      if (cancelled) return;

      if (freshUser) {
        setUser(freshUser);
      }

      setAllowed(canAccessCompanyCenter(freshUser?.role));
      setChecking(false);
    };

    void verify();

    return () => {
      cancelled = true;
    };
  }, [authInitialized, setUser]);

  if (!authInitialized || checking) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (!allowed) {
    return (
      <Navigate
        to={resolveDefaultRouteByRole(user?.role, preferMobileLayout)}
        replace
      />
    );
  }

  return <>{children}</>;
};

export default CompanyCenterGuard;
